import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import menu from './menu'
import basket from './basket'
import officeorder from './officeorder'
import customer from './customer'
import token from './token'
import user from './user'
import cookies from './cookies'
import scrollposition from './scrollposition'
import location from './location'
import 'es6-promise/auto'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const vuexLocal = new VuexPersistence({
  strictMode: true,
  storage: window.localStorage
})

export default new Vuex.Store({
  modules: {
    menu,
    basket,
    officeorder,
    customer,
    token,
    user,
    cookies,
    scrollposition,
    location
  },
  strict: debug,
  mutations: {
    RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION
  },
  plugins: [vuexLocal.plugin]
})



// WEBPACK FOOTER //
// ./src/store/index.js